import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getCollections, getCollectionItems } from "../utils/collectionsData";
import { seededShuffleForDay } from "../utils/dailyRandom";
import { GalleryDetailGrid } from "./GalleryDetailGrid";
import "./Portfolio.css";

/** Same fallback title derivation the backend uses, for when the API is unreachable. */
const titleFromKey = (key) => key.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const CollectionDetail = () => {
  const { key } = useParams();
  const [images, setImages] = useState([]);
  const [title, setTitle] = useState(() => titleFromKey(key));
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setTitle(titleFromKey(key));

    const fetchImages = async () => {
      setLoading(true);
      setError(null);
      try {
        const [items, collections] = await Promise.all([getCollectionItems(key), getCollections()]);
        setImages(seededShuffleForDay(items, `collection-grid:${key}`));
        const match = collections.find((c) => c.key === key);
        if (match?.name) setTitle(match.name);
      } catch (err) {
        console.error(`Error fetching ${key} collection:`, err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, [key]);

  return (
    <div className="collection-detail">
      <div className="collection-header">
        <Link to="/collections" className="back-link">
          ← Collections
        </Link>
        <h1>{title}</h1>
      </div>

      <GalleryDetailGrid
        items={images}
        loading={loading}
        error={error}
        altContext={title}
        emptyMessage="No images found in this collection."
      />
    </div>
  );
};

export default CollectionDetail;
